// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tab-container":"AerEwk","tab-container__green":"_1QTvTi","tab-container__neutral-darkest":"DZZC06","tab-container__red":"_20AlIx"};